import { render, staticRenderFns } from "./SelectorFilter.vue?vue&type=template&id=60685ac4&scoped=true"
import script from "./SelectorFilter.vue?vue&type=script&lang=js"
export * from "./SelectorFilter.vue?vue&type=script&lang=js"
import style0 from "./SelectorFilter.vue?vue&type=style&index=0&id=60685ac4&prod&lang=scss&scoped=true"
import style1 from "./SelectorFilter.vue?vue&type=style&index=1&id=60685ac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60685ac4",
  null
  
)

export default component.exports